import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { UserExternalInvestDto } from 'src/app/interfaces/user-external-invest.dto';
import Swal from 'sweetalert2';

declare const bootstrap: any; // Bootstrap 5 modal API

@Component({
  selector: 'investment-list',
  templateUrl: 'investment-list.component.html',
  styleUrls: ['investment-list.component.css'],
})
export class InvestmentListComponent implements OnInit {
  @Input() investments: UserExternalInvestDto[] = [];
  @Output() investmentsChange = new EventEmitter<UserExternalInvestDto[]>(); // <-- Agrega esto
  editIndex: number | null = null;
  editedInvestment: UserExternalInvestDto = new UserExternalInvestDto();
  isLoading: boolean = false;

  @ViewChild('investmentModalRef') investmentModalRef!: ElementRef;

  constructor() {}

  ngOnInit() {
    //
  }

  resetEdition() {
    this.editIndex = null;
    this.editedInvestment = new UserExternalInvestDto();
  }

  closeInvestmentModal() {
    const modalElement = this.investmentModalRef.nativeElement;
    const modalInstance = bootstrap.Modal.getOrCreateInstance(modalElement);
    modalInstance.hide();
  }

  validateEmail(email: string): boolean {
    // Expresión regular simple para validar emails
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }

  addInvestment() {
    if (
      this.validateEmail(this.editedInvestment.email) &&
      this.editedInvestment.tokens > 0
    ) {
      this.investments.push({ ...this.editedInvestment });
      this.investmentsChange.emit(this.investments); // <-- Notifica el cambio
      this.resetEdition();
      this.closeInvestmentModal(); // Cierra el modal al guardar
    } else {
      Swal.fire({
        title: 'Error',
        text: 'Por favor, introduce un email válido y una cantidad de tokens mayor a 0.',
        icon: 'error',
      });
    }
  }

  editInvestment(index: number) {
    this.editIndex = index;
    this.editedInvestment = { ...this.investments[index] };
  }

  saveEdit() {
    if (
      this.editIndex !== null &&
      this.validateEmail(this.editedInvestment.email) &&
      this.editedInvestment.tokens > 0
    ) {
      this.investments[this.editIndex] = { ...this.editedInvestment };
      this.investmentsChange.emit(this.investments); // <-- Notifica el cambio
      this.resetEdition();
      this.closeInvestmentModal(); // Cierra el modal al guardar
    } else {
      Swal.fire({
        title: 'Error',
        text: 'Por favor, introduce un email válido y una cantidad de tokens mayor a 0.',
        icon: 'error',
      });
    }
  }

  cancelEdit() {
    this.resetEdition();
  }

  async deleteInvestment(index: number) {
    const confirmResult = await Swal.fire({
      title: 'Confirmar borrado',
      html: `¿Estás seguro de que quieres borrar la inversión de <strong>${this.investments[index].email}</strong>?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, borrar',
      cancelButtonText: 'Cancelar',
    });

    if (!confirmResult.isConfirmed) {
      return; // Usuario canceló la operación
    }

    this.investments.splice(index, 1);
    this.investmentsChange.emit(this.investments); // <-- Notifica el cambio
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e: any) => {
      const text = e.target.result;
      const lines = text
        .split('\n')
        .map((l: string) => l.trim())
        .filter((l: string) => l);
      const newInvestments = [];
      for (const line of lines) {
        const [email, tokens] = line.split(',').map((v: string) => v.trim());
        if (email && tokens && !isNaN(Number(tokens))) {
          newInvestments.push(
            new UserExternalInvestDto(email, Number(tokens), '')
          );
        }
      }
      this.investments = [...newInvestments];
      this.investmentsChange.emit(this.investments); // <-- Notifica el cambio
    };
    reader.readAsText(file);
  }

  saveInvestments() {
    if (this.investments.length === 0) {
      Swal.fire({
        title: 'No hay inversiones',
        text: 'No hay inversiones para guardar.',
        icon: 'info',
      });
      return;
    }

    const filas = this.investments
      .map((i) => `${i.email},${i.tokens}`)
      .join('\n');
    const contenidoCSV = `${filas}`;

    const blob = new Blob([contenidoCSV], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('href', url);
    a.setAttribute('download', 'inversiones.csv');
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    Swal.fire({
      title: 'Inversiones guardadas',
      text: 'Las inversiones se han guardado correctamente.',
      icon: 'success',
    });

    this.resetEdition();
    this.closeInvestmentModal(); // Cierra el modal al guardar
  }

  getErrorMessage(error: string): string {
    if (error === 'no wallet') {
      return '&nbsp;&nbsp;* Sin billetera en Mangopay';
    } else if (error === 'unknown') {
      return '&nbsp;&nbsp;* Usuario desconocido';
    } else return '';
  }
}
